// export * from "./levels";

export const TON_TOKEN = {
  decimals: 9,
  name: "TON",
  symbol: "TON",
};

export const EMPTY_STRING = "";
export const COMING_SOON = "Coming soon...";

export const T_ME_HAPI_ANN = "https://telegram.me/hapi_ann";
export const HAPI_URL = "https://hapi.one/";
export const LEAR_MORE = "https://www.youtube.com/watch?v=lUDz44vUUc4&ab_channel=I%60mHAPI";

export const FEE = {
  NEAR: {
    MINT: 0.26,
    RE_MINT: 0.06,
    MINT_NFT: 0.5,
  },
  EVM: {
    MINT: 0.000286,
    RE_MINT: 0.000054,
    MINT_NFT: 0.01,
  },
};

export const DEFAULT_SCORE_FOR_MINT_NFT = 38;

export const TOAST_ID = {
  USER_DATA: "USER_DATA",
  HERE: "HERE",
  MINT: "MINT",
  TRUST_SCORE: "TRUST_SCORE",
  MINT_NFT: "MINT_NFT",
  AIRDROPS: "AIRDROPS",
  CLAIM_DROP: "CLAIM_DROP",
};

export const SWR_KEYS = {
  HERE: "HERE",
};

export const API_ERROR = {
  PAYMENT_NOT_FOUND: "Payment not found",
  NO_PAYMENT_TO_ORACLE: "No payment to Oracle",
  SOMETHING_WENT_WRONG: "Something went wrong. Try again later",
  USER_NOT_FOUND: "User not found",
  TELEGRAM_ALREADY_REGISTERED: "Wallet or telegram already registered",
  TIMEOUT: "Lock wait timeout exceeded; try restarting transaction",
};

export const DAYS_FOR_NOTIFICATION = 3;

//TODO: data from Irakli
export const AIRDROP_LINKS: Record<string, { x: string; global: string }> = {
  "d9c2d319cd7e6177336b0a9c93c21cb48d84fb54.factory.bridge.near": {
    x: "https://x.com/i_am_hapi_one",
    global: "https://score-be.hapi.mobi/",
  },
};
